// Initialize state from sessionStorage (auth_token, user, token_expire_time) and localStorage (refreshToken)
const getInitialState = () => {
    const userStr = sessionStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    const auth_token = sessionStorage.getItem('auth_token');
    const refresh_token = localStorage.getItem('refreshToken');
    const token_expire_time = sessionStorage.getItem('token_expire_time');
    
    return {
        isLoggedIn: !!auth_token,
        user: user,
        auth_token: auth_token,
        refresh_token: refresh_token,
        token_expire_time: token_expire_time ? parseInt(token_expire_time, 10) : null,
        loading: false,
        pageloading: false,
        error: null,
        message: null,
        all_users: [],
    };
};

const initialState = getInitialState();
  
export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_REQUEST':
            return { ...state, loading: true };       
        case 'LOGIN_SUCCESS':
            return { 
                ...state,
                user: null, // User will be set by USER action
                loading: false,
                pageloading: false,
                refresh_token: action.payload.refresh_token,
                auth_token: action.payload.id_token,
                token_expire_time: action.payload.expire_time ? Date.now() + action.payload.expire_time : null,
                isLoggedIn: true, 
                error: null,
                message: "Login Successfull!" 
            };
        case 'LOGIN_FAILURE':
            return { 
                loading: false, 
                user: null,
                isLoggedIn: false, 
                error: action.payload,
                message: action.payload,
                auth_token: null,
                refresh_token: null,
                token_expire_time: null,
                all_users: []
            };
        case 'REFRESH_TOKEN':
            return { 
                ...state, 
                auth_token: action.payload.id_token,
                token_expire_time: action.payload.expire_time ? Date.now() + action.payload.expire_time : state.token_expire_time,
                refresh_token: action.payload.refresh_token || state.refresh_token
            };
        case 'USER':
            return { ...state, user: action.payload, error: null, message: null };
        case 'ALL_USERS':
            return { ...state, all_users: (action.payload).reverse(), error: null, message: null };
        case 'CREATE_USER':
            return { ...state, all_users: [...state.all_users, action.payload], error: null, message: null };
        
        case 'CHECK_VALID_RESET_LINK_REQUEST':
            return { ...state, pageloading: true };
        case 'CHECK_VALID_RESET_LINK_SUCCESS':
            return { ...state, pageloading: false };
        case 'CHECK_VALID_RESET_LINK_FAILURE':
            return { 
                pageloading: false,
                loading: false, 
                user: null,
                isLoggedIn: false, 
                error: action.payload,
                message: action.payload,
                auth_token: null,
                refresh_token: null,
                token_expire_time: null,
                all_users: []
            };
        case 'LOGOUT_APP':
            return {  
                isLoggedIn: false,
                user: null,
                all_users: [],
                auth_token: null,
                refresh_token: null,
                token_expire_time: null,
                loading: false,
                error: null,
                message: action.payload 
            };
        default:
            return state;
    }
}
  